import { useState, createContext } from "react";
import MediaQuery from "../utilities/MediaQuery";
import {
  getStoredUserId,
  isAuthenticatedUser,
  isLoggedInUserInfo,
  readStoredToken,
} from "../utilities/AuthState";

export const UserContext = createContext();

const safeParseStorageJSON = (key, fallbackValue) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return fallbackValue;
    }

    const parsed = JSON.parse(raw);
    return parsed ?? fallbackValue;
  } catch (error) {
    return fallbackValue;
  }
};

const UserContextProvider = (props) => {
  const user = safeParseStorageJSON("user", {});
  const token = readStoredToken();
  const localCollection = safeParseStorageJSON("collectionId", []);
  const isAuthenticated = isAuthenticatedUser(user, token);

  const [userInformation, setUserInformation] = useState({
    userId: getStoredUserId(user),
    userType: user.userType || "",
    vendor: user.vendor || "",
    userName: user.userName || "",
    email: user.email || "",
    isLoggedIn: isAuthenticated,
  });

  const [collection, setCollection] = useState(
    Array.isArray(localCollection) ? localCollection : [],
  );

  const handleLogOutUser = () => {
    const logoutInfo = {
      userId: "",
      userType: "",
      vendor: "",
      userName: "",
      email: "",
      isLoggedIn: false,
    };
    setUserInformation(logoutInfo);
    localStorage.setItem("user", JSON.stringify(logoutInfo));
    localStorage.removeItem("token");
  };

  const media = MediaQuery();

  const value = {
    media,
    userInformation,
    changeUserInformation: (value) => {
      const nextValue = {
        userId: value?.userId || "",
        userType: value?.userType || "",
        vendor: value?.vendor || "",
        userName: value?.userName || "",
        email: value?.email || "",
        isLoggedIn: isLoggedInUserInfo(value),
      };

      setUserInformation(nextValue);
      localStorage.setItem("user", JSON.stringify(nextValue));
    },
    changelogOutUser: () => {
      handleLogOutUser();
    },
    collection,
    changeCollection: (value) => {
      if (collection.includes(value)) {
        setCollection(collection.filter((like) => like !== value));
        localStorage.setItem(
          "collectionId",
          JSON.stringify(collection.filter((like) => like !== value)),
        );
      } else {
        setCollection([...collection, value]);
        localStorage.setItem(
          "collectionId",
          JSON.stringify([...collection, value]),
        );
      }
    },
    updateCollection: (value) => {
      const nextCollection = Array.isArray(value) ? value : [];
      setCollection(nextCollection);
      localStorage.setItem("collectionId", JSON.stringify(nextCollection));
    },
  };

  return (
    <UserContext.Provider value={value}>{props.children}</UserContext.Provider>
  );
};

export default UserContextProvider;
